<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>PAN Number</mat-label>
      <input matInput #input [(ngModel)]="taxObj.panNumber">
    
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>TAN Number</mat-label>
      <input matInput #input [(ngModel)]="taxObj.tanNumber"/>
    
    </mat-form-field>
  </div>
  <div class="item_list add_padding">
    <div class="item_list_data add_margin_bottom">
      <span>GST Status</span>
      <mat-slide-toggle (change)="onToggleChange($event)" [checked]="taxObj.gstStatus == 1"></mat-slide-toggle>
    </div>
  </div>
  <div *ngIf="taxObj.gstStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>GST Number</mat-label>
      <input matInput #input [(ngModel)]="taxObj.gstNumber">
      
    </mat-form-field>
  </div>


  <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
    <div class="item_list_data add_margin_bottom">
      <span>CGST</span>
      <mat-slide-toggle (change)="onToggleChangeCGST($event)" [checked]="taxObj.cgstStatus == 1"></mat-slide-toggle>
    </div>
  </div>
  <div *ngIf="taxObj.cgstStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>CGST Rate</mat-label>
      <input matInput #input [(ngModel)]="taxObj.cgstValue"  smDecimalOnly  type="number"/>
      
    </mat-form-field>
  </div>


  <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
    <div class="item_list_data add_margin_bottom">
      <span>IGST</span>
      <mat-slide-toggle (change)="onToggleChangeIGST($event)" [checked]="taxObj.igstStatus == 1"></mat-slide-toggle>
    </div>
  </div>
  <div *ngIf="taxObj.igstStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>IGST Rate</mat-label>
      <input matInput #input [(ngModel)]="taxObj.igstValue"  smDecimalOnly  type="number"/>
     
    </mat-form-field>
  </div>


  <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
    <div class="item_list_data add_margin_bottom">
      <span>SGST</span>
      <mat-slide-toggle (change)="onToggleChangeSGST($event)" [checked]="taxObj.sgstStatus == 1"></mat-slide-toggle>
    </div>
  </div>
  <div *ngIf="taxObj.sgstStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>SGST Rate</mat-label>
      <input matInput #input [(ngModel)]="taxObj.sgstValue"  smDecimalOnly  type="number"/>
      
    </mat-form-field>
  </div>


  <div class="item_list add_padding" *ngIf="taxObj.gstStatus === 1">
    <div class="item_list_data add_margin_bottom">
      <span>UTGST</span>
      <mat-slide-toggle (change)="onToggleChangeUTGST($event)" [checked]="taxObj.utgstStatus == 1"></mat-slide-toggle>
    </div>
  </div>
  <div *ngIf="taxObj.utgstStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>UTGST Rate</mat-label>
      <input matInput #input [(ngModel)]="taxObj.utgstValue"  smDecimalOnly  type="number"/>
      
    </mat-form-field>
  </div>


  <div class="item_list add_padding" >
    <div class="item_list_data add_margin_bottom">
      <span>Service Tax</span>
      <mat-slide-toggle (change)="onToggleChangeServiceTax($event)" [checked]="taxObj.serviceTaxStatus == 1"></mat-slide-toggle>
    </div>
  </div>
  <div *ngIf="taxObj.serviceTaxStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>Service Tax Rate</mat-label>
      <input matInput #input [(ngModel)]="taxObj.serviceTaxValue"  smDecimalOnly  type="number"/>
      
    </mat-form-field>
  </div>


  <div class="item_list add_padding" >
    <div class="item_list_data add_margin_bottom">
      <span>Other Tax</span>
      <mat-slide-toggle (change)="onToggleChangeOtherTax($event)" [checked]="taxObj.otherTaxStatus == 1"></mat-slide-toggle>
    </div>
  </div>
  <div *ngIf="taxObj.otherTaxStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>Other Tax Name</mat-label>
      <input matInput #input [(ngModel)]="taxObj.otherTaxName"/>
      
    </mat-form-field>
  </div>
  <div *ngIf="taxObj.otherTaxStatus === 1">
    <mat-form-field appearance="outline">
      <mat-label>Other Tax Rate</mat-label>
      <input matInput #input [(ngModel)]="taxObj.otherTax"  smDecimalOnly  type="number"/>
      
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      (click)="onSubmitTaxDetails()"
      [disabled]="
      !taxObj.tanNumber &&
      !taxObj.panNumber 
      "
    >
      Confirm
    </button>
  </mat-dialog-actions>